type ColorFieldInputProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  uppercaseLabel?: boolean;
};

const normalizeColorPickerValue = (value: string): string => {
  if (!value) {
    return "#000000";
  }
  const trimmed = value.trim();
  const match = trimmed.match(/^#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i);
  if (!match) {
    return "#000000";
  }
  const hex = match[1];
  if (hex.length === 3) {
    return `#${hex
      .split("")
      .map((char) => `${char}${char}`)
      .join("")}`;
  }
  return `#${hex.slice(0, 6)}`;
};

export const ColorFieldInput = ({
  label,
  value,
  onChange,
  uppercaseLabel,
}: ColorFieldInputProps) => (
  <div className="flex flex-col gap-2 text-sm">
    <span
      className={`text-gray-300 ${
        uppercaseLabel ? "tracking-wide" : ""
      }`.trim()}
    >
      {label}
    </span>
    <div className="flex items-center gap-3">
      <input
        type="color"
        className="h-10 w-10 cursor-pointer rounded-md bg-transparent p-0 focus:outline-none"
        value={normalizeColorPickerValue(value)}
        onChange={(event) => onChange(event.target.value)}
        title={value || "Select color"}
      />
      <input
        type="text"
        className="flex-1 rounded-md border border-border bg-gray-900 px-3 py-2 text-sm focus:border-primary focus:outline-none"
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
    </div>
  </div>
);
